import React from 'react'

const TrustedHealthcare = () => {
    return (
        <section className="trusted-healthcare-area pt-70 pb-50">
            <div className="container">
                <div className="text-center">
                    <h2>Trusted by Healthcare Professionals</h2>
                    <p className='w-[600px]'>
                        For over a decade, we have worked alongside healthcare professionals to build technology that makes a real difference. The journey began with Dr. Saba Jamal's vision to improve patient safety through technology, and today that same commitment is reflected in every healthcare solution we build.{' '}
                        <br></br>
                        <span className="trusted-healthcare-text">
                            Read more about the inspiring vision of Dr. Saba Jamal.
                        </span>
                    </p>
                </div>
            </div>
        </section>
    )
}

export default TrustedHealthcare
